import React, { useContext } from 'react';
import * as R from 'ramda';

import { Collapse, List } from '@atom/mui';
import { MediaFolderTree } from '@atom/types/media';

import MoveFolderTreeContext from './MoveFolderTreeContext';
import MoveFolderTreeItem from './MoveFolderTreeItem';

type MoveFolderTreeListProps = {
  trees: MediaFolderTree[];
  level: number;
  isRoot?: boolean;
};

const MoveFolderTreeList = ({
  trees,
  level,
  isRoot,
}: MoveFolderTreeListProps) => {
  const { expandedIds } = useContext(MoveFolderTreeContext);

  return (
    <List disablePadding>
      {trees.map(tree => {
        const hasChildren =
          !R.isNil(tree.children) && !R.isEmpty(tree.children);

        return (
          <React.Fragment key={tree.id}>
            <MoveFolderTreeItem
              tree={tree}
              level={level}
              hasChildren={hasChildren}
              isRoot={isRoot ?? false}
            />
            {hasChildren && (
              <Collapse
                in={expandedIds.has(tree.id)}
                timeout="auto"
                unmountOnExit
              >
                <MoveFolderTreeList
                  trees={tree.children ?? []}
                  level={level + 1}
                />
              </Collapse>
            )}
          </React.Fragment>
        );
      })}
    </List>
  );
};

export default MoveFolderTreeList;
